/// <reference path="../global.d.ts" />

import { getCookies } from "../app/helpers/commonFunctions";

export const trackEvent = (
    eventAction : number| string,
    eventErrorCategory : string,
    eventLabel : string,
    eventUrl? : string,
    curruntScreen? : string,
    ListingAudience?: string | 'NA',
) => {
    (window as any).dataLayer = (window as any).dataLayer ?? [];
    (window as any).dataLayer.push({
        event: "UserInteraction",
        eventAction: eventAction,
        eventCategory: eventErrorCategory,
        eventLabel: eventLabel,
        fullUrl:eventUrl ?? "",
        curruntScreen: curruntScreen ?? "",
        country:getCookies().ecountry ?? 'jo',
        language:getCookies().NEXT_LOCALE ?? 'ar',
        Device:getCookies().source,
        ListingAudience: ListingAudience ?? 'NA',
    });
};

export const trackCustomEvent = (
    eventName: string = "UserInteraction",
    eventDetails: Record<string, any> = {},
) => {
    (window as any).dataLayer = (window as any).dataLayer ?? [];
    (window as any).dataLayer.push({
        event: eventName,
        ...eventDetails,
    });
};